/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import 'core-js/modules/es.string.replace';

const conditionEnumToText = (condition, newSubtr) => condition && condition.replace(/_/g, newSubtr || ' ');

export default conditionEnumToText;
//# sourceMappingURL=conditionEnumToText.js.map
